import { DEFAULT_WEIGHT_UNIT } from "constants/misc";
import { WeightUnits, WeightUnitSettings } from "interfaces/weight-units.type";

export const getWeightUnitSettings = (weightUnit: WeightUnits) => {
  return weightUnit
    ? WeightUnitSettings[weightUnit]
    : WeightUnitSettings[DEFAULT_WEIGHT_UNIT];
};
